import React, { useState } from "react";
import { toast } from "react-toastify";

export default function NoEtv() {
    const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
    const mosqueId = userProfile.mosqueId;
    const email = userProfile.emailMasjid || userProfile.email || "";
    const phone = userProfile.noTelAnda || "";
    const name = userProfile.namaMasjid || "Masjid";

    const [loading, setLoading] = useState(false);

    const handleActivateEtv = async () => {
        if (!mosqueId || !email) {
            toast.error("Maklumat masjid tidak lengkap. Sila semak profail anda.");
            return;
        }

        try {
            setLoading(true);
            toast.info("Menjana pautan pembayaran...");

            const response = await fetch(
                "https://us-central1-etikaf-admin.cloudfunctions.net/createBillplzPayment",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        email,
                        name,
                        phone,
                        submitterId: mosqueId,
                        type: "etv",
                    }),
                }
            );

            const data = await response.json();

            if (response.ok && data.billUrl) {
                window.location.href = data.billUrl; // terus buka Billplz
            } else {
                console.error("Error response:", data);
                toast.error("Gagal menjana pautan pembayaran.");
            }
        } catch (error) {
            console.error("Ralat pembayaran:", error);
            toast.error("Tidak dapat menjana pautan pembayaran. Cuba semula.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                maxWidth: "600px",
                margin: "100px auto",
                backgroundColor: "#fafafa",
                borderRadius: "12px",
                padding: "40px 30px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                textAlign: "center",
            }}
        >
            <img
                src="/images/etv-banner.png"
                alt="Ikon ETV"
                style={{
                    marginBottom: "25px",
                    opacity: 0.9,
                    width: 300
                }}
            />

            <h2 style={{ color: "#7A1777", fontWeight: 700, marginBottom: "15px" }}>
                Lengkapkan pakej Etikaf
            </h2>

            <p
                style={{
                    color: "#555",
                    fontSize: "15px",
                    lineHeight: 1.6,
                    marginBottom: "25px",
                }}
            >
                Akaun lama ini belum mempunyai peranti Etikaf TV. Lengkapkan pakej dengan
                bayaran sekali sebanyak <strong>RM3,000</strong> untuk peranti ETV.
            </p>

            <div style={{ background: "white", border: "1px solid #eadbea", borderRadius: 12, padding: 16, marginBottom: 22, textAlign: "left", color: "#555", fontSize: 13, lineHeight: 1.7 }}>
                <div>✓ Peranti plug and play</div>
                <div>✓ Penghantaran melalui pos</div>
                <div>✓ Waranti peranti 12 bulan</div>
                <div>✓ Kos penghantaran dikira berasingan</div>
            </div>

            <button
                onClick={handleActivateEtv}
                disabled={loading}
                style={{
                    backgroundColor: loading ? "#999" : "#7A1777",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 30px",
                    fontSize: "16px",
                    fontWeight: 600,
                    cursor: loading ? "not-allowed" : "pointer",
                    transition: "all 0.3s ease",
                }}
            >
                {loading ? "Menjana pautan..." : "Bayar RM3,000"}
            </button>

            <p
                style={{
                    color: "#999",
                    fontSize: "13px",
                    marginTop: "18px",
                }}
            >
                Untuk akaun baru, ETV dan Sistem Admin kini didaftarkan bersama sebagai satu pakej.
            </p>
        </div>
    );
}
